addEventListener('DOMContentLoaded', () => {
	initializeOfferForm()

	if (!document.body.classList.contains('contact')) {
		return
	}

	// Find the two contact forms.
	const placeholder = document.getElementById('contact-form-placeholder')
	const formsRow = document.getElementById('forms-row')
	const contactForm = formsRow.querySelector('#contact-form')
	const offerForm = formsRow.querySelector('#offer-form')

	formsRow.remove()

	function showForm(form) {
		placeholder.children[1]?.remove()
		placeholder.appendChild(form)
	}

	const radioButtons = document.querySelectorAll('input[name=form-type]')
	for (let a = 0; a < radioButtons.length; a++) {
		const index = a
		radioButtons[a].addEventListener('change', () => {
			showForm([contactForm, offerForm][index])
		})
	}

	// Initialize.
	showForm(offerForm)
})

function initializeOfferForm() {
	const offerForm = document.getElementById('offer-form')
	if (!offerForm) {
		return
	}

	//
	// Logic for the offer form.
	const reqText = offerForm.querySelector('.req-text')
	const submitButton = offerForm.querySelector('button')
	const subjectDropdown = offerForm.querySelector('#subject')

	const universal = ['#firstname', '#lastname', '#emailaddress', '#phonenr']
	const dependencies = {
		scm45: [...universal, '#customer-id', '#vehicle-type', '#dealer-vehicle', '#optional-license'],
		tvpeilzender: [...universal, '#customer-id', '#secure-object', '#object-type', '#dealer-object'],
		fiscaalservice: [...universal, '#customer-id', '#vehicle-type', '#dealer-vehicle', '#optional-license'],
		highrisk: [...universal, '#customer-id', '#vehicle-type', '#dealer-vehicle', '#optional-license'],
		fleetmanagement: ['.fleet-locator p'],
	}

	function showInputsForSubject(subject) {
		const allGroups = offerForm.querySelectorAll('div.form-group')
		for (let a = 0; a < allGroups.length; a++) {
			if (allGroups[a] != subjectDropdown.parentElement) {
				allGroups[a].classList.add('hidden')
			}
		}

		for (const query of dependencies[subject]) {
			const el = offerForm.querySelector(query)
			el?.parentElement?.classList.remove('hidden')

			if (el && !universal.includes(query)) {
				el.value = ''
			}
		}

		const hideSubmit = subject == 'fleetmanagement'
		submitButton.style.display = reqText.style.display = hideSubmit ? 'none' : 'block'
	}

	subjectDropdown.addEventListener('change', () => {
		showInputsForSubject(subjectDropdown.value)
	})

	showInputsForSubject('scm45')
}